import { PRE_REGISTRATION_REQUESTS_DATA} from "../../constants/ActionTypes";

const INIT_STATE = {
    preRegistrationRequests: []
};

const preRegistrationRequestReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case PRE_REGISTRATION_REQUESTS_DATA: {
            return {
                ...state,
                preRegistrationRequests: action.payload,
            }
        }
        default:
            return state;
    }
}

export default preRegistrationRequestReducer;
